import { sx } from '../../../lib/sx'
import type { Vals } from '../../../demo/vals'

export function UpgradeCheckout({ v }: { v: Vals }) {
  return (
    <div style={sx("position:absolute;inset:0;padding:56px 20px 34px;display:flex;flex-direction:column")}>
      <button onClick={v.openTerm} style={sx("width:36px;height:36px;flex:none;border-radius:var(--radius-full);border:none;background:var(--bg-tertiary);cursor:pointer;display:flex;align-items:center;justify-content:center;margin-bottom:14px")}>
        <span style={sx("width:18px;height:18px;background:var(--text-primary);-webkit-mask:url(/assets/icons/arrow-left.svg) center/contain no-repeat;mask:url(/assets/icons/arrow-left.svg) center/contain no-repeat")} />
      </button>
      <span style={sx("font-size:var(--fs-6xl);font-weight:var(--fw-bold);letter-spacing:var(--ls-sm);line-height:38px;margin-bottom:18px")}>
        Checkout
      </span>
      <div style={sx("border-radius:var(--radius-md);background:var(--bg-secondary);border:1px solid var(--border-secondary);margin-bottom:12px")}>
        <div style={sx("padding:14px 16px;display:flex;justify-content:space-between;gap:12px;border-bottom:1px solid var(--border-secondary)")}>
          <span style={sx("font-size:var(--fs-sm);color:var(--text-secondary)")}>
            {"Group · 5 accounts · "}
            {v.upTermLabel}
          </span>
          <span style={sx("display:flex;gap:8px;align-items:baseline")}>
            <span style={sx("font-size:var(--fs-sm);color:var(--text-secondary);text-decoration:line-through")}>
              {v.groupFullMonthly}
            </span>
            <span style={sx("font-size:var(--fs-sm)")}>
              {v.groupMonthly}
              /month
            </span>
          </span>
        </div>
        <div style={sx("padding:14px 16px;display:flex;justify-content:space-between;gap:12px")}>
          <span style={sx("font-size:var(--fs-sm);font-weight:var(--fw-medium)")}>
            {v.upfrontLabel}
          </span>
          <span style={sx("font-size:var(--fs-sm);font-weight:var(--fw-medium)")}>
            {v.upfrontTotal}
          </span>
        </div>
      </div>
      <div style={sx("border-radius:var(--radius-md);background:var(--bg-secondary);border:1px solid var(--border-secondary)")}>
        <div style={sx("padding:14px 16px;display:flex;justify-content:space-between;gap:12px;border-bottom:1px solid var(--border-secondary)")}>
          <span style={sx("display:flex;align-items:center;gap:6px")}>
            <span style={sx("font-size:var(--fs-sm);color:var(--text-secondary)")}>
              Pay now
            </span>
            <span style={sx("width:14px;height:14px;background:var(--text-secondary);-webkit-mask:url(/assets/icons/info.svg) center/contain no-repeat;mask:url(/assets/icons/info.svg) center/contain no-repeat")} />
          </span>
          <span style={sx("font-size:var(--fs-sm)")}>
            {v.upfrontTotal}
          </span>
        </div>
        <div style={sx("padding:14px 16px;display:flex;justify-content:space-between;gap:12px")}>
          <span style={sx("font-size:var(--fs-sm);color:var(--text-secondary)")}>
            {"Next bill · "}
            {v.nextBillDate}
          </span>
          <span style={sx("font-size:var(--fs-sm)")}>
            {v.upfrontTotal}
          </span>
        </div>
      </div>
      <div style={sx("margin-top:auto;display:flex;flex-direction:column;gap:8px")}>
        <span style={sx("font-size:var(--fs-2xs);line-height:15px;color:var(--text-secondary);text-align:center")}>
          All 5 accounts are charged upfront for the full term. Your Complete plan is billed separately, as before.
        </span>
        <button onClick={v.pay} style={sx("height:52px;border-radius:var(--radius-full);border:none;background:var(--bg-accent);color:#fff;font-family:inherit;font-size:var(--fs-md);font-weight:var(--fw-medium);cursor:pointer")}>
          {"Pay "}
          {v.upfrontTotal}
        </button>
      </div>
    </div>
  )
}
